/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Approval details
 * @export
 * @interface ApproveTenantRelationshipRequest
 */
export interface ApproveTenantRelationshipRequest {
    /**
     * ID of the relationship to approve
     * @type {string}
     * @memberof ApproveTenantRelationshipRequest
     */
    relationshipId: string;
    /**
     * Optional message or notes about the approval
     * @type {string}
     * @memberof ApproveTenantRelationshipRequest
     */
    approvalMessage?: string;
}

/**
 * Check if a given object implements the ApproveTenantRelationshipRequest interface.
 */
export function instanceOfApproveTenantRelationshipRequest(value: object): value is ApproveTenantRelationshipRequest {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    return true;
}

export function ApproveTenantRelationshipRequestFromJSON(json: any): ApproveTenantRelationshipRequest {
    return ApproveTenantRelationshipRequestFromJSONTyped(json, false);
}

export function ApproveTenantRelationshipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveTenantRelationshipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'approvalMessage': json['approvalMessage'] == null ? undefined : json['approvalMessage'],
    };
}

export function ApproveTenantRelationshipRequestToJSON(json: any): ApproveTenantRelationshipRequest {
    return ApproveTenantRelationshipRequestToJSONTyped(json, false);
}

export function ApproveTenantRelationshipRequestToJSONTyped(value?: ApproveTenantRelationshipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'approvalMessage': value['approvalMessage'],
    };
}

